// --- custom-script.js (Corrected Version) ---

if (typeof jQuery !== 'undefined') {
    // console.log('jQuery IS DEFINED when custom-script.js runs.');

    function forceBannerAspectRatio() {
        var $bannerSection = $('section.homepage-fade-slider');
        if ($bannerSection.length) {
            var currentWidth = $bannerSection.width();
            var newHeight = currentWidth * (680 / 1920);
            $bannerSection.css('height', newHeight + 'px');
            // console.log('NUCLEAR: Banner section height forced to ' + newHeight + 'px for width ' + currentWidth + 'px');
        }
    }

    $(document).ready(function() {
        // console.log('>>> $(document).ready() HAS FIRED SUCCESSFULLY! Initializing Slick...');

        // Slick Slider Initialization for .fade (existing code)
        $('.fade').slick({
            dots: true,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            autoplay: true,
            autoplaySpeed: 2000
        });
        // console.log('.fade slick initialization call made.');

        // Slick Slider Initialization for .fade2
        if ($('.fade2').length > 0) {
            // console.log('.fade2 element found. Initializing Slick with CUSTOM dots...');
            $('.fade2').on('init', function(event, slick) {
                var $sliderElement = $(this);
                var $sectionForInit = $sliderElement.closest('section.homepage-fade-slider');
                if ($sectionForInit.length) {
                    $sectionForInit.addClass('slider-ready-and-visible');
                }
            });

            $('.fade2').slick({
                dots: false,
                infinite: true,
                speed: 450, 
                autoplay: true,
                autoplaySpeed: 5000,
                fade: true,
                cssEase: 'ease-in-out', 
                lazyLoad: 'ondemand',
                adaptiveHeight: false,
                
                // SWIPE SETTINGS
                swipe: true,
                touchMove: true,
                touchThreshold: 20  // Changed from 10 to 20 for better sensitivity
            });
            // console.log('Slick for .fade2 call made (custom dots mode).');

            setTimeout(function() {
                var $section = $('.fade2').closest('section.homepage-fade-slider');
                if (!$section.hasClass('slider-ready-and-visible')) {
                    if ($section.length) {
                        $section.addClass('slider-ready-and-visible');
                    }
                }
            }, 500);

            // === FINAL & STABLE: Homepage Banner Dots ===
            var $homepageSlider = $('.fade2');

            if ($homepageSlider.length > 0) {
                // This removes any old event handlers to prevent conflicts.
                $homepageSlider.off('afterChange');
                $homepageSlider.off('beforeChange');

                // This is the reliable 'afterChange' event handler.
                $homepageSlider.on('afterChange', function(event, slick, currentSlide) {
                    // Clean up all dots first.
                    $homepageSlider.find('.my-custom-dots li').removeClass('slick-active');

                    // Find the dots inside the currently visible slide.
                    var $activeDots = $homepageSlider.find('.slick-current .my-custom-dots');

                    // Add the active class to the correct dot.
                    $activeDots.find('li[data-slide="' + currentSlide + '"]').addClass('slick-active');
                });

                // The click handler.
                $homepageSlider.on('click', '.my-custom-dots li button', function() {
                    var slideIndex = $(this).closest('li').data('slide');
                    $homepageSlider.slick('slickGoTo', slideIndex);
                });

                // Set the initial active dot when the page loads.
                setTimeout(function() {
                    $homepageSlider.find('.item:first-child .my-custom-dots li[data-slide="0"]').addClass('slick-active');
                }, 100);
            }
            // === END STABLE JS ===
        }
    });


    // Password Confirmation Check
    $(function() {
        $('#create_customer').submit(function(e) {
            if ($('input[name="customer[password]"]').val() != $('input[name="customer[password_confirmation]"]').val()) {
                e.preventDefault();
                alert('Passwords do not match.');
            }
        });

        var resizeTimerBannerHeight;
        $(window).on('resize', function() {
            clearTimeout(resizeTimerBannerHeight);
            resizeTimerBannerHeight = setTimeout(function() {}, 200);
        });
    });

    // Card Equal Height
    $(document).ready(function() {
        function setEqualHeight() {
            var maxHeight = 0;
            // Updated selector to be more specific if needed in the future
            var itemsToResize = $(".collection .grid__item, .template-search .grid__item");
            itemsToResize.css("min-height", "auto");
            itemsToResize.each(function() {
                var thisHeight = $(this).outerHeight();
                if (thisHeight > maxHeight) {
                    maxHeight = thisHeight;
                }
            });
            itemsToResize.css("min-height", maxHeight + "px");
        }

        // Only run this function if we are NOT on the search results page.
        if ($('.template-search').length === 0) {
            setEqualHeight();
            let resizeTimeout;
            $(window).resize(function() {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(setEqualHeight, 100);
            });
        }
    });

    // Card Label Height Equal
    $(document).ready(function() {
        function setMinLabelHeight() {
            var minLabelHeight = 0;
            $(".card__information h3 a").css("min-height", "auto");
            $(".card__information h3 a").each(function() {
                var thisHeight = $(this).outerHeight();
                if (thisHeight > minLabelHeight) {
                    minLabelHeight = thisHeight;
                }
            });
            $(".card__information h3 a").css("min-height", minLabelHeight + "px");
        }

        // CORRECTED CHECK: This checks if an element with the class .template-search
        // does NOT exist on the page. If it doesn't, we run the script.
        // This successfully disables the script on the search page.
        if ($('.template-search').length === 0) {
            setMinLabelHeight();
            $(window).resize(setMinLabelHeight);
        }
    });

    // =================================================================
    // == FINAL SCRIPT: Price FOUC Fix & Zero-Price Formatting (Rev 2) ==
    // =================================================================
    const finalizePrices = () => {
        if (!document.body.classList.contains('shop-detail')) { return; }
        document.body.classList.remove('price-is-loading');
        document.querySelectorAll('.money').forEach(priceElement => {
            const originalAmount = priceElement.dataset.bucksOriginalAmount;
            if (originalAmount === '0' || originalAmount === '0.00') {
                let currentText = priceElement.textContent.trim();
                const zeroValueRegex = /^(\S*?)\s*0(?:[.,])00$/;
                const match = currentText.match(zeroValueRegex);
                if (match) {
                    const currencySymbol = match[1] || '';
                    if (currentText !== `${currencySymbol}0`) {
                        priceElement.textContent = `${currencySymbol}0`;
                    }
                } else if (currentText.endsWith('0.00')) {
                    if (currentText !== currentText.replace('0.00', '0')) {
                        priceElement.textContent = currentText.replace('0.00', '0');
                    }
                } else if (currentText.endsWith('0,00')) {
                    if (currentText !== currentText.replace('0,00', '0')) {
                        priceElement.textContent = currentText.replace('0,00', '0');
                    }
                }
            }
        });
    };
    let bucksPollingInterval;
    const startBucksPricePolling = () => {
        clearInterval(bucksPollingInterval);
        let attempts = 0;
        const maxAttempts = 10;
        bucksPollingInterval = setInterval(() => {
            attempts++;
            const zeroValueElements = document.querySelectorAll('.money[data-bucks-original-amount="0"], .money[data-bucks-original-amount="0.00"]');
            let unformattedCount = 0;
            zeroValueElements.forEach(el => {
                const currentText = el.textContent.trim();
                if (currentText.endsWith('0.00') || currentText.endsWith('0,00')) {
                    unformattedCount++;
                }
            });
            if (unformattedCount > 0) {
                finalizePrices();
            } else {
                clearInterval(bucksPollingInterval);
            }
            if (attempts >= maxAttempts) {
                clearInterval(bucksPollingInterval);
            }
        }, 200);
    };
    if (document.body.classList.contains('shop-detail')) {
        document.body.classList.add('price-is-loading');
    }
    document.addEventListener('bucks:updated', finalizePrices);
    document.addEventListener('DOMContentLoaded', () => {
        finalizePrices();
        if (document.body.classList.contains('shop-detail')) {
            startBucksPricePolling();
        }
        setTimeout(() => {
            if (document.body.classList.contains('price-is-loading')) {
                document.body.classList.remove('price-is-loading');
            }
        }, 2000);
    });

    // =====================================================================
    // == START: Final "Launch" Serial Number Formatter (v6)              ==
    // =====================================================================
    $(document).ready(function() {
        let pollingInterval;
        function initializeSerialFormatter() {
            const serialInput = $('#48541-text-7');
            if (serialInput.length > 0) {
                clearInterval(pollingInterval);
                serialInput.on('input', function(e) {
                    let cursorPosition = this.selectionStart;
                    let originalValue = $(this).val();
                    let sanitizedValue = originalValue.toUpperCase().replace(/[^A-Z0-9]/g, '');
                    let finalValue = '';
                    if (sanitizedValue.length > 0) {
                        if (/[^A-Z]/.test(sanitizedValue[0])) {
                            sanitizedValue = sanitizedValue.substring(1);
                        }
                    }
                    if (sanitizedValue.length > 1) {
                        let firstChar = sanitizedValue[0];
                        let rest = sanitizedValue.substring(1).replace(/[^0-9]/g, '');
                        sanitizedValue = firstChar + rest;
                    }
                    if (sanitizedValue.length > 2) {
                        finalValue = sanitizedValue.slice(0, 2) + '-' + sanitizedValue.slice(2, 10);
                    } else {
                        finalValue = sanitizedValue;
                    }
                    $(this).val(finalValue);
                    let dashOffset = (finalValue.length > originalValue.length && finalValue.indexOf('-') === 2) ? 1 : 0;
                    let newCursorPosition = cursorPosition + dashOffset;
                    if (originalValue.length < 11) {
                        this.setSelectionRange(newCursorPosition, newCursorPosition);
                    }
                });
            }
        }
        pollingInterval = setInterval(initializeSerialFormatter, 200);
        setTimeout(function() {
            clearInterval(pollingInterval);
        }, 5000);
    });

    // =====================================================================
    // == START: Form Submission Validation for SN Length (v3 - Click Event) ==
    // =====================================================================
    $(document).ready(function() {
        $(document).on('click', 'form[data-id="48541"] .button.submit', function(e) {
            const serialInput = $('#48541-text-7');
            if (serialInput.length > 0 && serialInput.val().length > 0 && serialInput.val().length !== 11) {
                e.preventDefault();
                serialInput.val('');
                serialInput.focus();
                return false;
            }
        });
    });

    /* =================================================================== */
    /* == OK Boomer Co. - Smart Two-Stage Search Close (v2 - Final)      == */
    /* =================================================================== */
    document.addEventListener('DOMContentLoaded', () => {
        const searchModal = document.querySelector('details-modal.header__search');
        if (!searchModal) return;
        const detailsElement = searchModal.querySelector('details');
        const modalCloseButton = searchModal.querySelector('.search-modal__close-button');
        const searchInput = searchModal.querySelector('.search__input');
        const resetBtn = searchModal.querySelector('button[type="reset"]');
        if (modalCloseButton && searchInput && resetBtn && detailsElement) {
            modalCloseButton.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                if (searchInput.value.trim() !== '') {
                    resetBtn.click();
                    searchInput.focus();
                } else {
                    detailsElement.removeAttribute('open');
                }
            }, true);
        }
    });

} else {
    // This block is now at the end, correctly paired with the initial 'if'.
    console.error('jQuery IS NOT DEFINED when custom-script.js runs. Critical functions will fail.');
}



/* ────────────────────────────────────────────────────────────
   GIFT CARD — SINGLE SOURCE OF TRUTH (Cleaned Final Version)
   Handles initial load and user changes. Filtering handled in media-gallery.js.
────────────────────────────────────────────────────────────── */
(function () {
  if (!location.pathname.includes('/products/the-ok-digital-gift-card')) return;

  const SC      = 'slider-component[id^="GalleryViewer-"]';
  const SLIDE   = '.slider__slide';
  const RATIO   = 1460/1946; // For container height stability

  const qs  = (s, r=document) => r.querySelector(s);
  const qsa = (s, r=document) => Array.from(r.querySelectorAll(s));

  const getSC     = () => qs(SC);
  const getSlides = () => qsa(`${SC} ${SLIDE}`);

  // --- Utility Functions ---

  function findDesignSelect() {
    return (
      qs('select[id*="Design" i]') ||
      [...qsa('.product__info-container label, .product-form__input .form__label')]
        .find(l => (l.textContent||'').toLowerCase().includes('select your design'))
        ?.closest('.product-form__input')?.querySelector('select')
    );
  }

  function indexForDesign(label) {
    const needle = (label || '').toLowerCase().trim();
    if (!needle) return -1;
    const slides = getSlides();
    let i = slides.findIndex(li => {
      const img = qs('img', li); 
      const a1 = (img?.alt || '').toLowerCase();
      const a2 = (img?.getAttribute('data-media-alt') || '').toLowerCase();
      return a1.includes(needle) || a2.includes(needle);
    });
    if (i > -1) return i;

    const thumbs = qsa('thumbnail-list button, .thumbnail-list button, .product__media-thumbnail button');
    i = thumbs.findIndex(b => {
      const t = (b.getAttribute('aria-label') || b.title || b.textContent || '').toLowerCase();
      return t.includes(needle);
    });
    return i;
  }

  function activateIndex(i) {
    if (i < 0) return false;
    const thumbs = qsa('thumbnail-list button, .thumbnail-list button, .product__media-thumbnail button');
    
    if (thumbs[i]) { 
      // Most reliable method: Trigger the theme's thumbnail click handler
      thumbs[i].click(); 
      return true; 
    }
    return false;
  }
  
  function keepHeight() {
    const ul = document.querySelector(`${SC} .product__media-list`);
    if (!ul) return;
    const w = ul.getBoundingClientRect().width || ul.clientWidth;
    if (!w) return;
    ul.style.setProperty('height', Math.max(200, Math.round(w * RATIO)) + 'px', 'important');
  }

  function syncFromSelect() {
    const sel = findDesignSelect();
    if (!sel) return;

    const label = sel.options?.[sel.selectedIndex]?.text || sel.value || '';
    const idx = indexForDesign(label);
    
    if (idx > -1) {
      activateIndex(idx);
    }
  }

  // --- Lifecycle Hooks ---
  
  function reinit() {
    keepHeight(); 
    // Delay necessary for theme's HTML replacement/initialization to finish
    setTimeout(syncFromSelect, 100);
  }
  
  // 1. Initial Load & Manual Change Listener
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reinit, { once: true });
  } else {
    reinit();
  }
  
  document.addEventListener('change', (e) => {
    const sel = findDesignSelect();
    if (sel && e.target === sel) syncFromSelect();
  });
  
  // 2. Listen for section replacement after denomination change (now guaranteed to work)
  document.addEventListener('shopify:section:replaced', reinit);
  document.addEventListener('shopify:section:load', reinit);
})();